module.exports = __webpack_public_path__ + "img/img_sec_ticketintro_03.75dd1d0e.png";